This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="draggable drag-2" :class="[selected ? 'selected' : '']">
    <div class="variable" ref="varItem">
      <!-- Block as shown in the instructions container -->
      <div class="noRightBorder preview">
        {{ getTranslatedName() }}
      </div>

      <!-- Block as shown in the PSD/IDE -->
      <div class="hidden codeBlock parent psdVar" ref="var">
        <p>{{ getTranslatedName() }}</p>
        <div class="hidden">
          <div class="enumOptions">
            <div v-for="o in varData.options" :key="o">{{ o.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import * as types from "@/utils/Types";
import json from "@/psdLang/lang.json";

@Options({
  data() {
    return {
      lang: null,
      json: json,
      selected: false,
    };
  },
  name: "variable-block",
  beforeMount() {
    this.lang = this.$store.getters.getIDELanguage;
  },
  mounted() {
    this.selected = window.location.pathname == "/docent/levelmaker";

    if (this.varData.worldVar) {
      let varBlock = this.$refs.var;
      varBlock.classList.add("worldVar");
    }
    //Retrieve this instance of the VarBlock and add the type to the classlist
    let thisVar = this.$refs.varItem;
    thisVar.classList.add(this.varData.type);

    //Update the drag and drop containers, so that this element can be dragged
    this.$emit("updateContainers");
  },
  props: {
    varData: {} as types.varType,
  },
  methods: {
    /**
     * Get translation of the name if it's a worldvar
     */
    getTranslatedName() {
      if (this.varData.worldVar) return this.json[this.lang][this.varData.name];
      return this.varData.name;
    },
  },
})
export default class VarBlock extends Vue {}
</script>
